import { createContext, PropsWithChildren, useContext } from 'react';

import { StepModel } from '../../hooks';

export const StepsContext = createContext<StepModel<[undefined]> | undefined>(undefined);

export const StepsContextProvider = <
  const M extends readonly [undefined, ...unknown[]],
  const T extends StepModel<M>,
>({
  stepModel,
  children,
}: PropsWithChildren<{ stepModel: T }>) => {
  return (
    <StepsContext.Provider value={stepModel as StepModel<[undefined]>}>
      {children}
    </StepsContext.Provider>
  );
};

export function useStepsContext<T>() {
  const context = useContext(StepsContext);
  if (!context) {
    throw new Error('StepsContext not Provided');
  }
  return context as T;
}
